import { render, staticRenderFns } from "./PAB.vue?vue&type=template&id=76e94a5d&scoped=true"
import script from "./PAB.vue?vue&type=script&lang=js"
export * from "./PAB.vue?vue&type=script&lang=js"
import style0 from "./PAB.vue?vue&type=style&index=0&id=76e94a5d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76e94a5d",
  null
  
)

export default component.exports